import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lwa-reasons',
  templateUrl: './left-without-assistant-reasons.component.html',
  styleUrls: ['./left-without-assistant-reasons.component.scss']
})
export class LWAReasonsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
